module.exports = __webpack_public_path__ + "img/Tick.5a5b14c4.svg";